import {
    SearchFieldComponent as SourceSearchFieldComponent,
} from 'SourceComponent/SearchField/SearchField.component';

import './SearchField.override.style';
import { createRef } from 'react';
import ClickOutside from '@scandipwa/scandipwa/src/component/ClickOutside';
import SearchIcon from '@scandipwa/scandipwa/src/component/SearchIcon';
import CloseIcon from '@scandipwa/scandipwa/src/component/CloseIcon';
import SearchOverlay from '@scandipwa/scandipwa/src/component/SearchOverlay';
import Loader from '@scandipwa/scandipwa/src/component/Loader';
import { noopFn } from '@scandipwa/scandipwa/src/util/Common';
import { appendWithStoreCode } from '@scandipwa/scandipwa/src/util/Url';
import { scrollToTop } from '@scandipwa/scandipwa/src/util/Browser';
import React from "react";
import history from '@scandipwa/scandipwa/src/util/History';

export class SearchFieldComponent extends SourceSearchFieldComponent {
    static defaultProps = {
        isVisible: true,
        isActive: true,
        searchCriteria: '',
        hideActiveOverlay: noopFn,
    };

    searchBarRef = createRef();

    state = {
        searchCriteria: ""
    }

    __construct(props) {
        super.__construct?.(props);
        this.closeSearch = this.closeSearch.bind(this);
        this.onSearchEnterPress = this.onSearchEnterPress.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.openSearch = this.openSearch.bind(this);
        this.onClearSearchButtonClick = this.onClearSearchButtonClick.bind(this);
    }

    onClearSearchButtonClick() {
        const { onClearSearchButtonClick } = this.props;

        this.setState({
            searchCriteria: ""
        });

        onClearSearchButtonClick();
    }

    onSearchEnterPress(e) {
        const { searchCriteria, hideActiveOverlay, onSearchBarChange } = this.props;
        const search = encodeURIComponent(searchCriteria.trim().replace(/%/g, '%25'));
        const trimmedSearch = searchCriteria.trim();

        if (e.key === 'Enter' && trimmedSearch !== '') {
            history.push(appendWithStoreCode(`/search/${search}`));
            hideActiveOverlay();
            onSearchBarChange({ target: { value: '' } });
            this.searchBarRef.current?.blur();
            this.closeSearch();
            scrollToTop();
        }
    }

    onIconClick() {
        this.searchBarRef.current?.focus();
    }

    openSearch() {
        const { onSearchBarFocus } = this.props;

        onSearchBarFocus();
    }

    closeSearch() {
        const { onSearchOutsideClick } = this.props;

        onSearchOutsideClick();
    }

    handleChange(e) {
        this.setState({
            searchCriteria: e.target.value
        });
    }

    renderClearSearch() {
        return (
            <button
                onClick={this.onClearSearchButtonClick}
                aria-label="Clear search"
            />
        );
    }

    renderOverlayFallback() {
        return <Loader isLoading />;
    }

    renderSearch() {
        const {
            onSearchBarFocus,
            device,
        } = this.props;

        const { searchCriteria } = this.state;

        return (
            <>
                <div className='SearchField-SearchInnerWrapper'>
                    {this.renderSearchIcon()}
                    <input
                        id="search-field"
                        ref={this.searchBarRef}
                        onFocus={onSearchBarFocus}
                        onChange={this.handleChange}
                        onKeyDown={this.onSearchEnterPress}
                        value={searchCriteria}
                        placeholder={'Search'}
                        autoComplete="off"
                        aria-label={'Search'}
                        className='SearchField-Input'
                    />
                    {this.renderSearchIcon(true)}
                </div>
                <SearchOverlay
                    isHideOverlay={device.isMobile}
                    searchCriteria={searchCriteria}
                    closeSearch={this.onClearSearchButtonClick}
                />
            </>
        );
    }

    renderSearchIcon(isActive = false) {
        if (isActive) {
            return (
                <div
                    role="button"
                    tabIndex={0}
                    onClick={this.onClearSearchButtonClick}
                    aria-label={'Close'}
                    className='SearchField-CloseIcon'
                >
                    <CloseIcon />
                </div>
            );
        }

        return (
            <div
                role="button"
                tabIndex={0}
                // onClick={this.openSearch}
                aria-label={'Search'}
                className='SearchField-SearchIcon'
            >
                <SearchIcon />
            </div>
        );
    }

    render() {
        return (
            <div className='SearchField'>
                <ClickOutside onClick={this.closeSearch}>
                    <div className='SearchField-Wrapper'>
                        {this.renderSearch()}
                    </div>
                </ClickOutside>
            </div>
        );
    }
}

export default SearchFieldComponent;
